/**
 * Super-admin user UIDs (pricing shortcut, etc.).
 * Keep in sync with `backend/functions/agent/admin/constants.js`.
 */
export const ALLOWED_AGENT_ADMIN_USER_IDS = [
  'kIb0dHh5Mtdg5U5Eda7NFHk2cL83',
  'v3yIfTXpDgYRUaMn3u27SthdozW2',
];

export function isAgentAdminAllowed(user) {
  const uid = user?.uid;
  return !!uid && ALLOWED_AGENT_ADMIN_USER_IDS.includes(uid);
}
